import alt from '../alt';
import jpSetAction from '../actions/jpSetAction';

class jpSetStore {
    constructor() {
        this.bindActions(jpSetAction);
        this.processing = false;
        this.conversionRate = 0;
        this.emails = [];
    }

    onProcessing(data){
        this.processing = data;
    }
    onConversionRate(data){
        this.conversionRate = data;
    }
    onEmails(data){
        this.emails = data
    }
    onRemoveEmail(data){
        this.emails.splice(data,1);
    }
    onAddEmail(data){
        this.emails = this.emails.concat(data);
    }
}
export default alt.createStore(jpSetStore, 'jpSetStore');


// WEBPACK FOOTER //
// ./app/stores/jpSetStore.js